import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { userDetail } from "Stores/userDetail";
import { getGlobalTimeZones } from "Utils/commonAPI";
import TimezoneSelectDropdown from "Pages/Dashboard/settings/Schedules/TimezoneSelectDropdown";
import { findZoneOption } from "./DayOfWeekField";

/**
 * An agent schedule's time zone — the same picker as Settings → Schedules (common zones pinned,
 * search by city, country or EST / IST…), over the same list. Takes and returns the zone id
 * ("Asia/Kolkata"), which is what the agent scheduler reads.
 */
const AgentTimezoneField = observer(({ value = "", onChange = () => {} }) => {
  const zones = userDetail.globalTimeZone || [];

  useEffect(() => {
    if (!zones.length) getGlobalTimeZones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const current = findZoneOption(value, zones);
  return (
    // .ag-tz restyles the shared picker to match the agent pages' other dropdowns.
    <div className="ag-tz">
    <TimezoneSelectDropdown
      id="agentTimezone"
      text=""
      search
      options={zones}
      value={current ? current.displayName : value}
      change={(id, name) => onChange(name)}
    />
    </div>
  );
});

export default AgentTimezoneField;
